export const toggleSelection = <T>(arr: readonly T[], value: T): readonly T[] =>
    arr.includes(value) ? arr.filter((v) => v !== value) : [...arr, value];
